import { useEffect, useRef } from 'react';

export const ThumbnailCombine = ({ thumbnails }: { 
  thumbnails: string[]
}) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
      const canvas = canvasRef.current;
      if (!canvas) {return;}
      const ctx = canvas.getContext('2d');
      if (!ctx) {return;}

      const images = thumbnails.map((item) => {
        const img = new Image();
        img.src = 'data:image/jpeg;base64,' + item;
        return img;
      });

      Promise.all(images).then((images) => {
        const width = Math.min(...images.map((item) => item.width));
        const height = Math.min(...images.map((item) => item.height));
        canvas.width = width;
        canvas.height = height;
        ctx.clearRect(0, 0, width, height);
        images.forEach((item, index) => {
          ctx.drawImage(item, index * width / 2, 0, width / 2 + index * width / 2, height);
        });
        canvas.toBlob((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64 = reader.result as string;
            console.log(base64);
          };
          reader.readAsDataURL(blob);
        });
      });

      
     // const ctx = canvas.getContext('2d');
     // if (!ctx) {return;}
     // ctx.clearRect(0, 0, canvas.width, canvas.height);
     // ctx.drawImage(images[0], 0, 0, canvas.width, canvas.height);
     // ctx.drawImage(images[1], 0, 0, canvas.width, canvas.height);
     // ctx.drawImage(images[2], 0, 0, canvas.width, canvas.height);
     // ctx.drawImage(images[3], 0, 0, canvas.width, canvas.height);
    }, [thumbnails]);

    return <>
      <canvas width='100px' height='100px' ref={canvasRef} />
    </>;
};